export const surfaceWipesSpecifications = [
    {
        heading: "Features",
        features: [
            "Easy to use",
            "Very effective sterilization",
            "EPA registered"
        ]
    }
]; 